import {ES_TIP_TYPES, type ESTipType} from '@/consts/experienceScore/esTipTypes';

export type ESTipWrapper = 'gradient' | 'flatWarning' | 'flat';

export interface ESTipVariantConfig {
    wrapper: ESTipWrapper;
    titleSizeClass: string;
}

const DEFAULT_VARIANT: ESTipVariantConfig = {
    wrapper: 'gradient',
    titleSizeClass: 'text-14',
};

const VARIANT_BY_TYPE: Record<ESTipType, ESTipVariantConfig> = {
    [ES_TIP_TYPES.SUCCESS]: {wrapper: 'gradient', titleSizeClass: 'text-14'},
    [ES_TIP_TYPES.WARNING]: {wrapper: 'flatWarning', titleSizeClass: 'text-14'},
    [ES_TIP_TYPES.SUGGEST]: {wrapper: 'gradient', titleSizeClass: 'text-16'},
};

export const resolveESTipVariant = (type?: ESTipType): ESTipVariantConfig =>
    type ? VARIANT_BY_TYPE[type] : DEFAULT_VARIANT;
